import { api } from './api';

const createInsightShop = async datas => {
  try {
    const { data } = await api.post(`/insightShops`, datas);
    return data;
  } catch (err) {
    console.error(err);
    return [];
  }
};

const computeInsightShop = async id => {
  try {
    const { data } = await api.post(`/insightShops/compute/${id}`);
    return data;
  } catch (err) {
    console.error(err);
    return [];
  }
};

const update = async (id, payload) => {
  try {
    const { data } = await api.put(`/insightShops/${id}`, payload);
    return data;
  } catch (err) {
    console.error(err);
    return null;
  }
};

export default { createInsightShop, computeInsightShop, update };
